export const clubUserAuditStateEnum = [
    {
        stateId: "PENDING",
        stateName: "待审核"
    },
    {
        stateId: "APPROVED",
        stateName: "通过"
    },
    {
        stateId: "REJECTED",
        stateName: "拒绝"
    },
]
